import { TextField } from '@mui/material';
import { useFormContext, Controller } from 'react-hook-form';

interface RHFTextFieldProps {
  name: string;
  placeholder?: string;
  other?: object;
  rules?: object;
  label?: string;
  type?: string;
  defaultValue?: any;
  styles?: object;
  helpText?: string;
  onKeyDown?: () => void;
  onChange?: () => void;
}

export default function RHFTextField({
  name,
  placeholder,
  rules,
  type = 'text',
  label,
  defaultValue,
  styles,
  helpText,
  onChange,
  onKeyDown,
  ...other
}: RHFTextFieldProps) {
  const { control } = useFormContext();
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      rules={rules}
      render={({ field, fieldState: { error } }) => (
        <TextField
          fullWidth
          label={label}
          error={!!error}
          onKeyDown={onKeyDown}
          helperText={error?.message || helpText}
          placeholder={placeholder}
          {...other}
          {...field}
          style={styles}
          type={type}
          onChange={onChange}
        />
      )}
    />
  );
}
